// utils/loadMenu.js

import menuItems from 'menu-items';
import { secureLocalStorage } from "store/SecureStorage";

export default function loadMenuFromLocalStorage() {
    try {
        const stored = secureLocalStorage.get('_fn');
        if (!stored) return menuItems.items;

        const functions = stored;
        const grouped = {};

        functions.forEach((func) => {
            const category = func.category || 'General';
            if (!grouped[category]) grouped[category] = [];

            grouped[category].push({
                id: func.id,
                title: func.functionality,
                type: 'item',
                url: func.launch
            });
        });

        return Object.keys(grouped).map((category, index) => ({
            id: `cat-${index}`,
            title: category,
            type: 'group',
            children: grouped[category]
        }));
    } catch (e) {
        console.error('Error loading menu:', e);
        return menuItems.items;
    }
}
